import React from 'react';
import { DollarSign, Award, TrendingUp, PieChart } from 'lucide-react';
import { MetricCard } from '../ui/MetricCard';
import { SectionHeader } from '../ui/SectionHeader';
import { loanOfficers, companyTotals } from '../data/mockData';
export function ResultsSection() {
  const formatCurrency = (val: number) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(val);
  // Find top performer for highlighting
  const maxRevenue = Math.max(...loanOfficers.map(lo => lo.results.revenue));
  return <section className="space-y-6 animate-in fade-in duration-500" data-id="element-142">
      <SectionHeader title="Results (Outcome)" description="Final production numbers and revenue generation." data-id="element-143" />

      {/* KPI Cards */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-144">
        <MetricCard title="Locks MTD" value={companyTotals.results.locksMTD} icon={Award} trend="up" trendValue="12%" data-id="element-145" />
        <MetricCard title="Funded Units" value={companyTotals.results.fundedUnits} icon={CheckCircleIcon} trend="up" trendValue="8%" data-id="element-146" />
        <MetricCard title="Funded Volume" value={formatCurrency(companyTotals.results.fundedVolume)} icon={DollarSign} trend="up" trendValue="15%" data-id="element-147" />
        <MetricCard title="Total Revenue" value={formatCurrency(companyTotals.results.revenue)} icon={TrendingUp} color="green" trend="up" trendValue="18%" data-id="element-148" />
        <MetricCard title="Rev per LO" value={formatCurrency(Math.round(companyTotals.results.revenue / loanOfficers.length))} icon={PieChart} data-id="element-149" />
        <MetricCard title="Rev / Funded File" value={formatCurrency(Math.round(companyTotals.results.revenue / companyTotals.results.fundedUnits))} icon={DollarSign} data-id="element-150" />
      </div>

      {/* Results Table */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-151">
        <div className="overflow-x-auto" data-id="element-152">
          <table className="w-full text-sm text-left" data-id="element-153">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-154">
              <tr data-id="element-155">
                <th className="px-6 py-4" data-id="element-156">Loan Officer</th>
                <th className="px-6 py-4 text-right" data-id="element-157">Locks MTD</th>
                <th className="px-6 py-4 text-right" data-id="element-158">Funded Units</th>
                <th className="px-6 py-4 text-right" data-id="element-159">Funded Vol</th>
                <th className="px-6 py-4 text-right" data-id="element-160">Revenue</th>
                <th className="px-6 py-4 text-right" data-id="element-161">Rev / LO</th>
                <th className="px-6 py-4 text-right" data-id="element-162">Rev / Funded File</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-163">
              {loanOfficers.map(lo => <tr key={lo.id} className={`hover:bg-slate-50 transition-colors ${lo.results.revenue === maxRevenue ? 'bg-green-50/50' : ''}`} data-id="element-164">
                  <td className="px-6 py-4 font-medium text-slate-900 flex items-center gap-2" data-id="element-165">
                    {lo.results.revenue === maxRevenue && <Award className="h-4 w-4 text-amber-500" data-id="element-166" />}
                    {lo.name}
                  </td>
                  <td className="px-6 py-4 text-right text-slate-600" data-id="element-167">
                    {lo.results.locksMTD}
                  </td>
                  <td className="px-6 py-4 text-right text-slate-600" data-id="element-168">
                    {lo.results.fundedUnits}
                  </td>
                  <td className="px-6 py-4 text-right text-slate-600" data-id="element-169">
                    {formatCurrency(lo.results.fundedVolume)}
                  </td>
                  <td className="px-6 py-4 text-right font-bold text-slate-900" data-id="element-170">
                    {formatCurrency(lo.results.revenue)}
                  </td>
                  <td className="px-6 py-4 text-right text-slate-600" data-id="element-171">
                    {formatCurrency(lo.results.revenuePerLO)}
                  </td>

                  {/* Conditional formatting for Rev/File */}
                  <td className="px-6 py-4 text-right" data-id="element-172">
                    <span className={`px-2 py-1 rounded-md text-xs font-bold ${lo.results.revenuePerFundedFile >= 7000 ? 'bg-green-100 text-green-800' : lo.results.revenuePerFundedFile >= 6500 ? 'bg-amber-100 text-amber-800' : 'bg-red-100 text-red-800'}`} data-id="element-173">
                      {formatCurrency(lo.results.revenuePerFundedFile)}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}
// Missing icon import fix
function CheckCircleIcon(props: any) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-174">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" data-id="element-175" />
      <polyline points="22 4 12 14.01 9 11.01" data-id="element-176" />
    </svg>;
}